// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noDateShow[data-v-1111a2f5]{height:100%;width:100%;position:absolute;top:0;left:0;background-color:hsla(0,0%,100%,.7);z-index:100;text-align:center;line-height:33.333vw}", ""]);
// Exports
module.exports = exports;
